import { render, staticRenderFns } from "./AddWorkflowOwners.vue?vue&type=template&id=6612a734"
import script from "./AddWorkflowOwners.vue?vue&type=script&lang=js"
export * from "./AddWorkflowOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports